import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import snakeCaseKeys from 'snakecase-keys';
import { Spinner } from 'react-bootstrap';

import { sendAlert } from '../../../actions/utils';
import { createMassiveOvertimeRequest } from '../../../requests/overtimes';
import OvertimesBossForm from '../../Overtime/OvertimesBossForm';

const OvertimeBossNew = ({ onSuccess }) => {
  const [onRequest, setOnRequest] = useState(false);
  const dispatch = useDispatch();

  const handleSuccessCreate = setSubmitting => {
    setSubmitting(false);
    const message = 'Horas Extras creadas con éxito';
    setOnRequest(false);
    dispatch(sendAlert({ kind: 'success', message }));
    if (onSuccess) onSuccess(); // <-- cerrar formulario y mostrar datatable
  };

  const handleFailureRequest = error => {
    setOnRequest(false);
    dispatch(sendAlert({ kind: 'error', message: error.response?.data?.message }));
  };

  const validateLength = overtimeValues => {
    if (!overtimeValues.overtimes.length) {
      dispatch(sendAlert({ kind: 'error', message: 'Debes seleccionar al menos un trabajador' }));
      return true;
    }
    return false;
  };

  const handleCreate = (overtimeValues, setSubmitting) => {
    if (validateLength(overtimeValues)) {
      return;
    }
    setOnRequest(true);

    createMassiveOvertimeRequest({
      dispatch,
      params: snakeCaseKeys(overtimeValues),
      formData: true,
      successCallback: () => handleSuccessCreate(setSubmitting),
      failureCallback: error => {
        handleFailureRequest(error);
        setSubmitting(false);
      }
    });
  };

  return (
    <>
      {onRequest && <Spinner animation="border" variant="primary" className="spinner-modal" />}
      <OvertimesBossForm action="new" formRequest={handleCreate} />
    </>
  );
};

export default OvertimeBossNew;
